
import Overlay from '../overlay';
import Spinner from '../../spinner';

export default {
  name: 'SpinnerModal',
  components: {
    Spinner,
    Overlay,
  },
  props: {
    showModal: {
      type: Boolean,
      default: true,
    },
  },
};
